import React from 'react';

const IncomePremiumHouseholdFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10 5L10.7725 6.64564L12.5 6.91115L11.25 8.19138L11.545 10L10 9.14564L8.455 10L8.75 8.19138L7.5 6.91115L9.2275 6.64564L10 5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.99967 17.4987V13.332" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.99967 13.332L8.33301 14.9987" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.6667 14.9987L10 13.332" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M6.66667 12.5H4.16667C3.24583 12.5 2.5 11.7542 2.5 10.8333V4.16667C2.5 3.24583 3.24583 2.5 4.16667 2.5H15.8333C16.7542 2.5 17.5 3.24583 17.5 4.16667V10.8333C17.5 11.7542 16.7542 12.5 15.8333 12.5H13.3333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IncomePremiumHouseholdFilterIcon;
